import { getScannerVolumeMultiplier } from './scannerVolume';

let audioContext = null;

export const unlockScannerAudio = () => {
    try {
        const AudioContext = window.AudioContext || window.webkitAudioContext;
        if (!AudioContext) return null;
        if (!audioContext || audioContext.state === 'closed') {
            audioContext = new AudioContext();
        }
        if (audioContext.state === 'suspended') {
            void audioContext.resume();
        }
        return audioContext;
    } catch {
        return null;
    }
};

export const playScannerTone = (type) => {
    const context = unlockScannerAudio();
    if (!context) return;

    const tones = {
        success: { wave: 'sine', from: 920, to: 1320, volume: 0.18, duration: 0.17 },
        repeat: { wave: 'triangle', from: 520, to: 640, volume: 0.14, duration: 0.24 },
        error: { wave: 'square', from: 175, to: null, volume: 0.11, duration: 0.37 },
    };
    const tone = tones[type] || tones.error;

    const start = () => {
        if (context.state !== 'running') return;
        const oscillator = context.createOscillator();
        const gain = context.createGain();
        const now = context.currentTime;
        oscillator.type = tone.wave;
        oscillator.frequency.setValueAtTime(tone.from, now);
        if (tone.to) {
            oscillator.frequency.exponentialRampToValueAtTime(tone.to, now + tone.duration * 0.7);
        }
        const volume = Math.max(0.0001, tone.volume * getScannerVolumeMultiplier());
        gain.gain.setValueAtTime(0.0001, now);
        gain.gain.exponentialRampToValueAtTime(volume, now + 0.01);
        gain.gain.exponentialRampToValueAtTime(0.0001, now + tone.duration);
        oscillator.connect(gain);
        gain.connect(context.destination);
        oscillator.start(now);
        oscillator.stop(now + tone.duration + 0.01);
    };

    if (context.state === 'running') {
        start();
        return;
    }
    void context.resume().then(start);
};
